
import * as utils from '@/lib/utils.js'
export default {
  components: {},
  props: {
    menu: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    getSubmenuOptions: utils.getSubmenuOptions,
    getSubmenuFilterKey: utils.getSubmenuFilterKey,
    onOver(element) {
      this.$refs[element][0].visible = true
    },
    onLeave(element) {
      this.$refs[element][0].visible = false
    },
    isExternal(url) {
      if (!url || typeof url !== 'string') return false;
      return url.startsWith('http://') || url.startsWith('https://');
    },
  },
}
